import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';
import { FormGroup, FormControl } from '@angular/forms';
import { InformesService } from 'app/services/informes.service';
import { CarteraService } from 'app/services/cartera/cartera.service';

@Component({
  selector: 'app-reporte-pago',
  templateUrl: './reporte-pago.component.html',
  styleUrls: ['./reporte-pago.component.scss']
})
export class ReportePagoComponent implements OnInit {

  newForm: FormGroup;

  constructor(@Inject(MAT_DIALOG_DATA) private _data, public dialog: MatDialogRef<ReportePagoComponent>, private _snackBar: MatSnackBar, private _cartera: CarteraService) {
    this.newForm = this.createForm();
  }

  ngOnInit() {
  }

  createForm(): FormGroup {
    return new FormGroup({
      pago: new FormControl(),
      usuario_creador: new FormControl(JSON.parse(localStorage.getItem('usuario'))['id_usuario'])
    });
  }

  public saveReportePago(form: FormGroup){
    this._cartera.ReportePago(this._data.id_cobro, form).subscribe((data: any) => {

      if(data.affectedRows == 1){
        this._snackBar.open('Reporte pago realizado', 'Aceptar', {
          duration: 2000
        });
        this.dialog.close();
      }else{
        this._snackBar.open('Error en el reporte del pago', '', {
          panelClass: ['warn-600'],
          duration: 2000
        });
      }
    });
  }

}
